"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SocialMediaIcon = void 0;
var _components = require("@ori-ui/components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = _interopRequireDefault(require("react"));
var _models = require("../../../models");
var _constants = require("../constants");
var _jsxRuntime = require("react/jsx-runtime");
const SocialMediaIcon = ({
  type,
  title,
  url
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const kind = _models.SocialMediaIcons[type];
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.SocialIcon, {
    kind: kind,
    size: "medium",
    component: "a",
    "data-testid": getTestId(_constants.SOCIAL_MEDIA_ICON),
    "aria-label": title ?? '',
    href: url ?? '',
    title: title ?? ''
  });
};
exports.SocialMediaIcon = SocialMediaIcon;
